// ─────────────────────────────────────────────────────────────────────────────
// Stepper — the numbered 1·2·3 rail in the wizard header.
//   Three states per dot: done (green outline), current (filled green), and
//   upcoming (dim). The connector to the right of a dot lights up once that dot
//   is behind us, so progress reads left-to-right at a glance.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./AddNodeWizard.module.css";

export default function Stepper({ current, total }) {
  const steps = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <ol className={styles.stepper} aria-label={`Step ${current} of ${total}`}>
      {steps.map((step) => {
        const done = step < current;
        const isCurrent = step === current;
        return (
          <li key={step} className={styles.stepItem}>
            <span
              className={[
                styles.stepDot,
                done && styles.stepDotDone,
                isCurrent && styles.stepDotCurrent,
              ].filter(Boolean).join(" ")}
              aria-current={isCurrent ? "step" : undefined}
            >
              {step}
            </span>
            {step < total && (
              <span className={`${styles.stepLine} ${done ? styles.stepLineDone : ""}`} />
            )}
          </li>
        );
      })}
    </ol>
  );
}
